<template>
    <div>
        <rkm-area
            title="Procedimentos - EMAD"
            type="box"
            background-color="primary"
            closed
        >
            <rkm-row>
                <rkm-col cols="12">
                    <rkm-form-checkbox-group
                        name="Procedimentos - EMAD"
                        v-model="data.model.procedimentosEmad"
                    >
                        <rkm-form-checkbox
                            v-for="procedimento in data.form.procedimentosEmad"
                            :key="procedimento.codigo"
                            :value="procedimento"
                            class="w-50 m-0"
                        >
                            {{ procedimento.nome }}
                        </rkm-form-checkbox>
                    </rkm-form-checkbox-group>
                </rkm-col>
            </rkm-row>
        </rkm-area>
    </div>
</template>

<script>
export default {
    props: {
        data: {type: Object, required: true},
    },
}
</script>